import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LinkBroken01 = function LinkBroken01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 4V2m6 18v2M4 9H2m18 6h2M4.9142 4.9142 3.5 3.5m15.5858 15.5858L20.5 20.5M12 17.6569l-2.1213 2.1213c-1.5621 1.5621-4.0948 1.5621-5.6569 0s-1.562-4.0948 0-5.6569L6.3431 12m11.3138 0 2.1213-2.1213c1.5621-1.5621 1.5621-4.0948 0-5.6569s-4.0948-1.562-5.6569 0L12 6.3431"
    })
  }));
};
export default LinkBroken01;